var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 64,
    viewBox: "0 0 75 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9444 9.73913H68.0556M50 0V64V0ZM25 0V64V0ZM0 50.087H75H0ZM0 36.1739H75H0ZM0 22.2609H75H0ZM6.94444 9.73913H18.0556H6.94444ZM31.9444 9.73913H43.0556H31.9444Z",
    stroke: "#949494",
    strokeWidth: 3.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsTable);
export default __webpack_public_path__ + "static/media/statisticsTable.e6116ed5f9a768eeac31e7d750f2f6b2.svg";
export { ForwardRef as ReactComponent };